import type { AlpineComponent, Stores } from 'alpinejs'

export const navigation = () => ({
  navExpanded: false,

  init() {
    const mainNav = document.querySelector('nav#main-nav')
    if (!mainNav) return

    // Reset open submenu (and possible open mobile menu) when going between mobile and desktop
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.intersectionRatio === 1 && this.navExpanded) {
          this.toggleMobileMenu()
        } else {
          this.resetOpenSubmenu()
        }
      },
      { root: document.querySelector('#navigation-grid') }
    )
    observer.observe(mainNav)
  },

  resetOpenSubmenu() {
    const nav = document.querySelector('nav#main-nav')
    if (!nav) return

    // The submenu of the current page should be opened by default on mobile.
    // The currently open submenu should be closed when closing the mobile menu or going from desktop to mobile view.
    this.navExpanded
      ? nav.querySelector('.subnav:has([aria-current="true"])')?.setAttribute('open', '')
      : nav.querySelector('.subnav[open]')?.removeAttribute('open')
  },

  toggleMobileMenu() {
    this.navExpanded = !this.navExpanded
    this.resetOpenSubmenu()
  },

  MainNav: {
    ':aria-expanded': 'navExpanded',
  },

  NavToggle: {
    '@click': 'toggleMobileMenu',
    ':aria-pressed': 'navExpanded',
    'aria-controls': 'main-nav',
  },
})

type SubNavComponent = {
  expanded: boolean
  toggleSubNav: (e: PointerEvent) => void
  SubNav: Stores
  SubNavLink: Stores
}

export const subNavWrapper = (): AlpineComponent<SubNavComponent> => ({
  expanded: false,

  init() {
    this.expanded = !!this.$root.querySelector('[aria-current=true]')
  },

  // Open the sub nav instead of using as a link when the sub nav arrows are visible (on mobile)
  toggleSubNav(e: PointerEvent) {
    if (getComputedStyle(this.$el, '::after').display !== 'none') {
      e.preventDefault()
      this.expanded = !this.expanded
    }
  },

  SubNav: {
    ':aria-expanded': 'expanded',
    'x-show': 'expanded',
    'x-cloak': '',
    'x-collapse': '',
  },

  SubNavLink: {
    '@click': 'toggleSubNav($event)',
  },
})
